import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem, FileUpload } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";
import { PrestarConta } from '../../../entity/prestar-conta';
import { Justificar } from '../../../entity/justificar';
import { PrestarContaInstrutor } from '../../../entity/prestar-conta-instrutor';
 
@Component({
    selector: 'curso-prestacao-conta-etapa3',
    templateUrl: './curso-prestacao-conta-etapa3.component.html',
})
export class CrudCursoPrestacaoContaEtapa3Component extends BaseStepComponent{
    @Input() validateForm: any = false;
    @Input() listaDiasSemana:any[] = [];
    @Input() listaPais:any[] = [];
    @Input() listaUf:any[] = [];
    @Input() listaCidades:any[] = [];
    @Input() hoje = new Date();
    DataMinima = new Date();
    @Input() isHomologacao: boolean = false;
    turmaDataValida = new Date();
 
    @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
    @Output() validateFormChange = new EventEmitter<any>();

    init() {
        let rota = this.activatedRoute.snapshot.url[0].path;
        if (rota == "turma-incluir"){
            this.DataMinima.setDate(this.DataMinima.getDate() + 5);
        }
        else{
            this.DataMinima  = new Date(98, 0);
        }
       

        this.cadastro.get('id_pais').valueChanges.subscribe(x => {
            if(x == 31){
                this.cadastro.get('id_uf').setValidators([Validators.required]);
                this.cadastro.get('id_cidade').setValidators([Validators.required]);
                this.cadastro.get('id_uf').updateValueAndValidity();
                this.cadastro.get('id_cidade').updateValueAndValidity();
                this.cadastro.get('id_uf').valueChanges.subscribe(value => {
                    if (value !== null && value !== undefined && value !== '') {
                        this.service.ListarTodos('cidade', { id_estado: value }).subscribe(data =>{
                            this.listaCidades = data
                        }
                        );
                    }
                });
            }else{
                
                this.cadastro.get('id_uf').clearValidators();
                this.cadastro.get('id_cidade').clearValidators();
                this.cadastro.get('id_uf').updateValueAndValidity();
                this.cadastro.get('id_cidade').updateValueAndValidity();
                this.cadastro.get('id_uf').setValue(null);
                this.cadastro.get('id_cidade').setValue(null);
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/curso-prestacao-conta/crud/etapas/curso-prestacao-conta-etapa3.component.ts